import nodelistToArray from './utils/nodelist_to_array';

export default class PlayerDoubleTapSeek {
  constructor(tech) {
    this._tech = tech;
    this._skipInterval = 10;
    this.lastTapDirection = null;
    this.tapListenerTimeout = null;
    this.tapEffectTimeout = null;
    this._targetedHideElements = [];
    this.icons = { backward: {}, forward: {} };
    this.resetTapCount();
  }

  tech() {
    return this._tech;
  }

  skipInterval() {
    return this._skipInterval;
  }

  el() {
    return this.tech().el();
  }

  getCurrentTime() {
    return Math.floor(this.tech().currentTime());
  }

  setCurrentTime(time) {
    this.tech().currentTime(time);
  }

  getDuration() {
    return Math.floor(this.tech().duration());
  }

  targetedHideElements() {
    return this._targetedHideElements;
  }

  init() {
    this.appendDoubleTapFeedbackElement();
    this.assignIcons();
    this.setTargetedHideElement();
    this.bindOnTouchStart();
    this.bindOnTouchEnd();
  }

  assignIcons() {
    this.icons.backward = {
      first: document.querySelector(`#double_tap_backward_1__start`),
      second: document.querySelector(`#double_tap_backward_2__start`),
      third: document.querySelector(`#double_tap_backward_3__start`)
    };

    this.icons.forward = {
      first: document.querySelector(`#double_tap_forward_1__start`),
      second: document.querySelector(`#double_tap_forward_2__start`),
      third: document.querySelector(`#double_tap_forward_3__start`)
    };
  }

  calculateDirection(clientWidth, clientX){
    return (clientX < clientWidth / 2) ? "backward" : "forward";
  }

  bindOnTouchStart(){
    this.tech().on('touchstart', (e) => {
      const clientWidth = e.currentTarget.clientWidth;
      const clientX = e.changedTouches[0].clientX;
      const direction = this.calculateDirection(clientWidth, clientX);

      if(this.tapCount[direction] === 0){
        this._userInactive = this.tech().el().hasClass('vjs-user-inactive');
      }
    });
  }

  bindOnTouchEnd() {
    this.tech().on('touchend', (e) => {
      const clientHeight = e.currentTarget.clientHeight;
      const clientY = e.changedTouches[0].clientY;

      if(this.canSeek(clientHeight, clientY)){
        const clientWidth = e.currentTarget.clientWidth;
        const clientX = e.changedTouches[0].clientX;
        const direction = this.calculateDirection(clientWidth, clientX);

        this.tapCount[direction]++;

        if (this.tapCount[direction] === 1) {
          this.tapListenerTimeout = setTimeout(() => {
            this.resetTapCount();
          }, 500);
        } else if (this.tapCount[direction] > 1) {
          window.clearTimeout(this.tapListenerTimeout);
          this.doubleTapHandler(direction);
        }
      }
    });
  }

  canSeek(clientHeight, yPos){
    if(this._userInactive){
      return true;
    } else {
      let controlBarHeight = this.tech().controlBar().height();

      return yPos < (clientHeight - controlBarHeight - 20);
    }
  }

  setTargetedHideElement() {
    const elements = document.querySelectorAll('.vjs-big-button, .vjs-control-bar');
    this._targetedHideElements = nodelistToArray(elements);
  }

  createDoubleTapFeedbackElement(direction) {
    const container = document.createElement('div');
    container.className = `vjs-double-tap-feedback vjs-double-tap-feedback--${direction}`;

    const svg = document.createElement('div');
    svg.className = "animated-svg";
    svg.innerHTML = this.getAnimatedSvg(direction);

    const interval = document.createElement('div');
    interval.className = "interval";

    container.appendChild(svg);
    container.appendChild(interval);

    return container;
  }

  appendDoubleTapFeedbackElement() {
    this.el().appendChild(this.createDoubleTapFeedbackElement('backward'));
    this.el().appendChild(this.createDoubleTapFeedbackElement('forward'));
  }

  doubleTapHandler(direction) {
    this.tech().trigger({
      type: 'vp-before-seeked',
      action: 'doubletap'
    });

    if (direction === "backward" && this.getCurrentTime() > 0 ) {
      this.seekBackward();
      this.toggleDoubleTapSeekedClass('backward');
    } else if (direction === "forward" && this.getCurrentTime() < this.getDuration()) {
      this.seekForward();
      this.toggleDoubleTapSeekedClass('forward');
    } else {
      this.resetTapCount();
    }
  }

  toggleDoubleTapSeekedClass(direction) {
    this.handleIntervalElement(direction);
    this.el().addClass(`vjs-double-tap-seeked-${direction}`);
    this.hideTargetedElement();
    this.startDoubleTapAnimation(direction);

    this.tapEffectTimeout = window.setTimeout(() => {
      this.resetElement(direction);
    }, 1000);
  }

  handleIntervalElement(direction) {
    if (this.lastTapDirection != null) {
      if (this.lastTapDirection != direction) {
        this.resetElement(this.lastTapDirection);
      } else {
        window.clearTimeout(this.tapEffectTimeout);
      }
    }

    this.updateInterval(direction);
    this.lastTapDirection = direction;
  }

  updateInterval(direction) {
    var intervalElement = document.querySelector(`.vjs-double-tap-feedback.vjs-double-tap-feedback--${direction} .interval`);
    var interval = (this.tapCount[direction] - 1) * this.skipInterval();
    intervalElement.innerHTML = `${interval} seconds`;
  }

  resetElement(direction) {
    this.showTargetedElement();
    this.el().removeClass(`vjs-double-tap-seeked-${direction}`);
    this.tapCount[direction] = 0;
    this.lastTapDirection = null;
  }

  hideTargetedElement() {
    this.targetedHideElements().forEach( element => { element.classList.add('vjs-override-transition') } );
    this.targetedHideElements().forEach( element => { element.classList.add('vjs-invisible') } );
  }

  showTargetedElement() {
    this.targetedHideElements().forEach( element => { element.classList.remove('vjs-override-transition') } );
    this.targetedHideElements().forEach( element => { element.classList.remove('vjs-invisible') } );
  }

  startDoubleTapAnimation(direction) {
    this.icons[direction].first.beginElement();
    this.icons[direction].second.beginElement();
    this.icons[direction].third.beginElement();
  }

  resetTapCount() {
    this.tapCount = { backward: 0, forward: 0 };
  }

  seekForward() {
    this.setCurrentTime(this.getCurrentTime() + this.skipInterval());
  }

  seekBackward() {
    this.setCurrentTime(this.getCurrentTime() - this.skipInterval());
  }

  getAnimatedSvg(direction) {
    return `
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="48px" height="16px" viewBox="0 0 48 16" version="1.1">
        <title>Animated SVG</title>
        <defs>
          <path d="M3.68277588,2.34138794 C2.20111967,1.60055984 1,2.34237885 1,4.00335124 L1,11.9966488 C1,13.6553538 2.19363213,14.4031839 3.68277588,13.6586121 L12.3172241,9.34138794 C13.7988803,8.60055984 13.8063679,7.40318394 12.3172241,6.65861206 L3.68277588,2.34138794 Z" id="play-icon" fill="white"/>
        </defs>
        <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Atoms-/-Attributes-/-Player-/-BW-10s" transform="translate(-7.000000, -8.000000)">
            <g id="Group" transform="translate(7.000000, 8.000000)">
              <g id="Icons" transform="translate(24.000000, 8.000000) scale(-1, 1) translate(-24.000000, -8.000000) ">
                <g id="${direction}-icon-1" class="opacity-0">
                  <rect id="Bound" x="0" y="0" width="16" height="16"/>
                  <g id="Shape">
                    <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#play-icon"/>
                  </g>
                </g>
                <g id="${direction}-icon-2" class="opacity-0" transform="translate(16.000000, 0.000000)" opacity="0.5">
                  <rect id="Bound" x="0" y="0" width="16" height="16"/>
                  <g id="Shape">
                    <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#play-icon"/>
                  </g>
                </g>
                <g id="${direction}-icon-3" class="opacity-0" transform="translate(32.000000, 0.000000)">
                  <rect id="Bound" x="0" y="0" width="16" height="16"/>
                  <g id="Shape">
                    <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#play-icon"/>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
        <animate id="double_tap_${direction}_1__start" href="#${direction}-icon-1" attributeName="class" begin="indefinite" values="opacity-50;opacity-100;opacity-50;opacity-0;" dur="0.4"/>

        <animate id="double_tap_${direction}_2__start" href="#${direction}-icon-2" attributeName="class" begin="indefinite" values="opacity-0;" dur="0.2"/>
        <animate id="double_tap_${direction}_2__show" href="#${direction}-icon-2" attributeName="class" begin="double_tap_${direction}_2__start.end" values="opacity-50;opacity-100;opacity-50;opacity-0;" dur="0.48"/>

        <animate id="double_tap_${direction}_3__start" href="#${direction}-icon-3" attributeName="class" begin="indefinite" values="opacity-0;" dur="0.44"/>
        <animate id="double_tap_${direction}_3__show" href="#${direction}-icon-3" attributeName="class" begin="double_tap_${direction}_3__start.end" values="opacity-50;opacity-100;opacity-50;opacity-0;" dur="0.56"/>
      </svg>
    `;
  }
}
